import React from 'react'
import { UsersTab } from '../modules/users';

export const UsersPage = () => {
    return (
        <UsersTab />
    );
}
